import { enhancedTmsApiService } from '#api/enhancements/enhancedTmsApiService'
import type { EnhancedMarketId } from '#api/enhancements/enhancedTmsApiTypes'
import type { AdminNatCodesMarket } from '#api/tmsApiService'
import { store } from '#app/store'
import { toastError } from '#features/ErrorHandling/toastError'

type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] }

export type MarketWithNationalCodes = WithRequired<AdminNatCodesMarket, 'groups'>

export async function loadNationalCodes(marketId: EnhancedMarketId): Promise<MarketWithNationalCodes> {
  const request = store.dispatch(enhancedTmsApiService.endpoints.getAdmintoolMarketsByMarketId.initiate({ marketId, recursive: true }))
  const result = await request.unwrap()

  if (!result.market) {
    throw new Error(`Market with ID ${marketId} not found`)
  }

  if (!result.market.groups) {
    toastError(new Error(`Market with ID ${marketId} has no national codes groups defined`))
    return { ...result.market, groups: [] } as MarketWithNationalCodes
  }

  return result.market as MarketWithNationalCodes
}
